export const HISTORY_TYPE_FILTER_MAP = {
  accumulation: { cash: 'ACCUMULATE', point: 'ACCRUE', label: '적립' },
  usage: { cash: 'USE', point: 'USE', label: '사용' },
  reclaimed: { cash: 'RECLAIMED', point: 'EXPIRE', label: '소멸' },
  deduct: { cash: 'DEDUCT', point: 'DEDUCT', label: '차감' },
} as const;

export type HistoryTypeParamValue = keyof typeof HISTORY_TYPE_FILTER_MAP;

export const CURRENCY_TAB = {
  CASH: 'cash',
  POINT: 'point',
} as const;

export type CurrencyTab = (typeof CURRENCY_TAB)[keyof typeof CURRENCY_TAB];

export const POINT_HISTORY_INITIAL_PAGE = 1;
export const POINT_HISTORY_PAGE_SIZE = 50;
export const PARTNER_POINT_HISTORY_PAGE_SIZE = 20;

export const PENDING_REWARD_SECTION_ID = 'pending-rewards';
